import React from "react";
import classNames from 'classnames'

const Sandbox = ({ theme, children }) => {
  const sandboxClass = classNames('demo-wrapper', {
    'bg-tertiary-900 dark': theme === 'dark',
    'bg-neutral-0 light bc-neutral-100 ba': theme === 'light',
  })
  return <div className={sandboxClass}>{children}</div>;
};

Sandbox.defaultProps={
  theme: 'dark'
}
export default Sandbox;
